/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Status_Vo_FailedInputs */

const en_audio_description_export_status_vo_failed = /** @type {(inputs: Audio_Description_Export_Status_Vo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to export audio VO`)
};

const fr_audio_description_export_status_vo_failed = /** @type {(inputs: Audio_Description_Export_Status_Vo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de l'export de la VO`)
};

const de_audio_description_export_status_vo_failed = /** @type {(inputs: Audio_Description_Export_Status_Vo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audioexport (Sprachausgabe) fehlgeschlagen`)
};

const it_audio_description_export_status_vo_failed = /** @type {(inputs: Audio_Description_Export_Status_Vo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile esportare l'audio VO`)
};

const ru_audio_description_export_status_vo_failed = /** @type {(inputs: Audio_Description_Export_Status_Vo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось экспортировать аудиозапись.`)
};

const es_audio_description_export_status_vo_failed = /** @type {(inputs: Audio_Description_Export_Status_Vo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo exportar el audio VO`)
};

const zh_cn2_audio_description_export_status_vo_failed = /** @type {(inputs: Audio_Description_Export_Status_Vo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出音频 VO 失败`)
};

const ja_audio_description_export_status_vo_failed = /** @type {(inputs: Audio_Description_Export_Status_Vo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオVOのエクスポートに失敗しました`)
};

const hi_audio_description_export_status_vo_failed = /** @type {(inputs: Audio_Description_Export_Status_Vo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो वॉयस ओवर निर्यात करने में विफल।`)
};

const pt_pt2_audio_description_export_status_vo_failed = /** @type {(inputs: Audio_Description_Export_Status_Vo_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha na exportação do áudio VO`)
};

/**
* | output |
* | --- |
* | "Failed to export audio VO" |
*
* @param {Audio_Description_Export_Status_Vo_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_status_vo_failed = /** @type {((inputs?: Audio_Description_Export_Status_Vo_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Status_Vo_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_status_vo_failed(inputs)
	if (locale === "de") return de_audio_description_export_status_vo_failed(inputs)
	if (locale === "it") return it_audio_description_export_status_vo_failed(inputs)
	if (locale === "ru") return ru_audio_description_export_status_vo_failed(inputs)
	if (locale === "es") return es_audio_description_export_status_vo_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_status_vo_failed(inputs)
	if (locale === "ja") return ja_audio_description_export_status_vo_failed(inputs)
	if (locale === "hi") return hi_audio_description_export_status_vo_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_status_vo_failed(inputs)
	return en_audio_description_export_status_vo_failed(inputs)
});